import Grid from "@mui/material/Grid";
import MKTypography from "components/MKTypography";

function Explanation() {
  return (
    <Grid container spacing={2} py={2}>
      <Grid item xs={12}>
        <MKTypography variant="body2" align="center">
          Op deze pagina kun je de prijzen van de diensten op de website aanpassen.
        </MKTypography>
        <MKTypography variant="body2" align="center">
          <strong>Belangrijk:</strong> prijswijzigingen voor abonnementen gelden alleen voor nieuwe
          abonnementen. Bestaande gebruikers behouden hun oorspronkelijke prijs. Bijvoorbeeld: als
          iemand zich heeft aangemeld voor €10 per maand, dan blijft dat zo — ook als je de prijs
          voor nieuwe klanten aanpast.
        </MKTypography>
      </Grid>
    </Grid>
  );
}

export default Explanation;
